import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';
import { EMAIL_TEMPLATE_CATEGORIES_TYPE } from 'store/system/actions';

const initialState = {};

const emailTemplateCategoriesReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case EMAIL_TEMPLATE_CATEGORIES_TYPE.GET_CATEGORIES:
      return payload || state;

    case EMAIL_TEMPLATE_CATEGORIES_TYPE.ADD_CATEGORY:
      return { ...state, [payload.id]: payload };

    case EMAIL_TEMPLATE_CATEGORIES_TYPE.REMOVE_CATEGORY:
      return _.omit(state, meta.emailTemplateCategoryId);

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default emailTemplateCategoriesReducer;
